import type { SVGProps } from 'react';

import { cn } from '@crm/shared/lib/styles/utils';

import type { TSvgIcon } from '@crm/shared/model/SvgIcon.type';

type SvgIconProps = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    icon: TSvgIcon;
    size?: SVGProps<SVGSVGElement>['width'];
    title?: string;
};

export const SvgIcon = ({
    icon: Icon,
    size = 20,
    className,
    title,
    role,
    'aria-hidden': ariaHidden,
    'aria-label': ariaLabel,
    ...props
}: SvgIconProps) => {
    const hasAccessibleName = Boolean(ariaLabel || title);

    return (
        <Icon
            width={size}
            height={size}
            className={cn('shrink-0', className)}
            focusable="false"
            role={role ?? (hasAccessibleName ? 'img' : undefined)}
            aria-hidden={ariaHidden ?? (hasAccessibleName ? undefined : true)}
            aria-label={ariaLabel ?? title}
            {...props}
        />
    );
};

export type { SvgIconProps };
